import ComponentLoader from './component_loader';
import ConfigLoader from './config_loader';
export { ComponentLoader, ConfigLoader };


// WEBPACK FOOTER //
// ./src/index.js